import React, { useState } from 'react'
import res_arrow from '../../assets/images/homePage/reserve_arrow.svg'
import usdc from "../../assets/images/homePage/USDC.svg";
import usdt from "../../assets/images/homePage/USDT.svg";
import dai from "../../assets/images/homePage/DAI.svg";
import ave from "../../assets/images/homePage/ave.svg";
import compound from "../../assets/images/homePage/compound.svg";

const ReserveBacking = () => {
  const [tab, settab] = useState("1");

  const res_backing = [
    {
      rate: "50%",
      crypto: "USDC",
      crypto_logo: usdc,
      transaction: "On Chain"
    },
    {
      rate: "20%",
      crypto: "DAI",
      crypto_logo: dai,
      transaction: "On Chain"
    },
    {
      rate: "20%",
      crypto: "USDT",
      crypto_logo: usdt,
      transaction: "On Chain"
    },
    {
      rate: "20%",
      crypto: "aUSDC Aave",
      crypto_logo: compound,
      transaction: "On Chain"
    },
    {
      rate: "10%",
      crypto: "aUSDC Aave",
      crypto_logo: ave,
      transaction: "On Chain"
    },
  ]
  return (
    <div>
      <div className="main_container py-[30px] md:py-[80px]">

        {/* table section */}

        <div className="pt-[20px] flex items-center justify-between">
          <p className="text-[#fff] aeonik_medium text-[24px] md:text-[32px]">
            Reserve Backing <span className='text-[#26DDF9]'>Max Allowance</span>  by Dao
          </p>
          <div className=" flex items-center rounded-[10px] bg-[#1a1c1d] p-[4px]">
            <div
              onClick={() => settab("1")}
              className={`${tab === "1" && "bg-[#fff]"
                } rounded-[6px] py-[3px] cursor-pointer px-[6px]`}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.75 6.75H20.25M3.75 12H20.25M3.75 17.25H20.25"
                  stroke={`${tab === "1" ? "#010304" : "#fff"}`}
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div
              onClick={() => settab("2")}
              className={`${tab === "2" && "bg-[#fff]"
                } rounded-[6px] py-[5px] px-[8px] cursor-pointer`}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.875 11.25C1.875 7.45304 4.95304 4.375 8.75 4.375C9.09518 4.375 9.375 4.65482 9.375 5V10.625H15C15.3452 10.625 15.625 10.9048 15.625 11.25C15.625 15.047 12.547 18.125 8.75 18.125C4.95304 18.125 1.875 15.047 1.875 11.25Z"
                  fill={`${tab === "2" ? "#010304" : "#fff"}`}
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.625 2.5C10.625 2.15482 10.9048 1.875 11.25 1.875C15.047 1.875 18.125 4.95304 18.125 8.75C18.125 9.09518 17.8452 9.375 17.5 9.375H11.25C10.9048 9.375 10.625 9.09518 10.625 8.75V2.5Z"
                  fill={`${tab === "2" ? "#010304" : "#fff"}`}
                />
              </svg>
            </div>
          </div>
        </div>

        <table className="w-full my-[32px]">
          <thead className="bg-[#1c2023] h-[30px] ">
            <tr>
              <th className="pl-[10px] md:pl-[30px] rounded-l-[8px] text-left aeonik_medium text-[11px] md:text-[14px] text-[#8d8f91]">RATE</th>
              <th className=" text-left aeonik_medium text-[11px] md:text-[14px] text-[#8d8f91]">CRYPTO</th>
              <th className=" md:text-left rounded-r-[8px] aeonik_medium text-[11px] md:text-[14px] text-[#8d8f91]">TRANSACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='pt-[16px]'></td>
            </tr>
            {
              res_backing?.map((d, i) => {
                return (
                  <tr className="border border-b-[#1a1c1d]" key={i}>
                    <td className="text-white text-[14px] md:text-[18px] pl-[10px] md:pl-[30px]  py-[16px] aeonik_bold">{d.rate}</td>
                    <td className="py-[16px]">
                      <div className="flex items-center">
                        <img src={d.crypto_logo} alt="usdc"></img>
                        <p className="text-white text-[14px] md:text-[18px] pl-[8px] aeonik_normal">{d.crypto}</p>
                      </div>
                    </td>
                    <td className="text-white  py-[16px] text-[14px] md:text-left text-end aeonik_normal">{d.transaction}</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
        <div className="grid grid-cols-12 gap-x-[15px] lg:gap-x-[48px] md:mt-[64px]">
          <div className="col-span-12 md:col-span-6 p-[32px] ReserveBacking_gradiant_1 flex items-center justify-between rounded-[24px] cursor-pointer border-[1px] border-black outline outline-2 outline-offset-2 outline-[#32353B]">
            <p className="text-[18px] text-white aeonik_medium leading-[22px]">DAO Votes for <br /> Max Allowance</p>
            <a className="p-[16px] rounded-full bg-white">
              <img src={res_arrow} alt='res' className='h-[13px] w-auto object-contain' />
            </a>
          </div>
          <div className="col-span-12 mt-[20px] md:mt-0 md:col-span-6 p-[32px] ReserveBacking_gradiant_2 flex items-center justify-between rounded-[24px] cursor-pointer border-[1px] border-black outline outline-2 outline-offset-2 outline-[#32353B]">
            <p className="text-[18px] text-white aeonik_medium leading-[22px]">DAO Votes for <br /> Reserve Backing Distribution</p>
            <a className="p-[16px] rounded-full bg-white">
              <img src={res_arrow} alt='res' className='h-[13px] w-auto object-contain' />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReserveBacking
